import { motion } from "framer-motion";
import { Building2, Video } from "lucide-react";

const LIM_IMG =
  "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxjaW5lbWF0b2dyYXBoZXIlMjBmaWxtJTIwc2V0fGVufDB8fHx8MTc4ODAzMDI1Nnww&ixlib=rb-4.1.0&q=85";
const STUDIO_IMG =
  "https://images.unsplash.com/photo-1611784728558-6c7d9b409cdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxjaW5lbWF0b2dyYXBoZXIlMjBmaWxtJTIwc2V0fGVufDB8fHx8MTc4ODAzMDI1Nnww&ixlib=rb-4.1.0&q=85";

const PANELS = [
  {
    n: "01",
    icon: Building2,
    name: "Life Inside Media",
    kind: "THE PRODUCTION HOUSE — PUNE",
    title: "A production house brands already trust.",
    text: "LIMA runs inside Life Inside Media — a Pune-based video production company with 10+ years of work for national and multinational brands, including international clients. Your classroom briefs come from that desk, and your showreel carries work made for them.",
    img: LIM_IMG,
    caption: "LIM — LIVE PRODUCTION FLOOR",
  },
  {
    n: "02",
    icon: Video,
    name: "Lime Studios",
    kind: "THE STUDIO — PRO GRADE",
    title: "Pro-grade gear. Your hands on it.",
    text: "Lime Studios is our professional studio floor — the latest cinema-line cameras, lighting and shooting gear, maintained for client work. Students don't read about this equipment; they train on it, from the first week.",
    img: STUDIO_IMG,
    caption: "LIME STUDIOS — CINEMA-LINE GEAR",
  },
];

export default function HouseSection() {
  return (
    <section className="bg-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-white/10" data-testid="house-section">
      <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-lima-paper leading-[0.98] mb-10 md:mb-20">
        An academy with
        <br />
        <span className="font-serifit font-normal text-lima-blue">a real house behind it.</span>
      </h2>
      <div className="grid lg:grid-cols-2 gap-px bg-white/10 border border-white/10">
        {PANELS.map((p, i) => (
          <motion.article
            key={p.n}
            initial={{ opacity: 0, y: 30, filter: "blur(10px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="bg-lima-ink"
            data-testid={`house-panel-${p.n}`}
          >
            <div className="relative h-52 md:h-64 overflow-hidden group">
              <img
                src={p.img}
                alt={p.name}
                loading="lazy"
                className="w-full h-full object-cover saturate-[.65] opacity-75 group-hover:opacity-95 group-hover:scale-105 transition-[opacity,transform] duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-lima-ink via-transparent to-transparent" />
              <span className="absolute bottom-3 left-4 font-mono2 text-[10px] tracking-[0.25em] text-white/80 bg-black/60 backdrop-blur px-2.5 py-1 border border-white/10">
                {p.caption}
              </span>
            </div>
            <div className="p-8 md:p-10">
              <div className="flex items-center justify-between mb-6">
                <span className="font-serifd text-4xl text-lima-blue leading-none">{p.n}</span>
                <p.icon size={20} className="text-white/40" />
              </div>
              <p className="font-mono2 text-[11px] tracking-[0.25em] text-white/40 mb-2">{p.kind}</p>
              <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-lima-paper mb-4">{p.title}</h3>
              <p className="text-sm md:text-base text-white/60 leading-relaxed">{p.text}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
